export const STREET_TYPE_ITEMS = [
    { value: '001', label: 'akna' },
    { value: '002', label: 'akna-alsó' },
    { value: '003', label: 'állomás' },
    { value: '004', label: 'alsórakpart' },
    { value: '005', label: 'árok' },
    { value: '006', label: 'átjáró' },
    { value: '007', label: 'autóút' },
    { value: '008', label: 'bánya' },
    { value: '009', label: 'bányatelep' },
    { value: '010', label: 'barakképület' },
    { value: '011', label: 'bástya' },
    { value: '012', label: 'bástyája' },
    { value: '013', label: 'bekötőút' },
    { value: '014', label: 'csárda' },
    { value: '015', label: 'csónakházak' },
    { value: '016', label: 'domb' },
    { value: '017', label: 'dűlő' },
    { value: '018', label: 'dűlőút' },
    { value: '019', label: 'egyéb' },
    { value: '020', label: 'elágazás' },
    { value: '021', label: 'emlékpark' },
    { value: '022', label: 'emlékút' },
    { value: '023', label: 'erdészház' },
    { value: '024', label: 'erdészlak' },
    { value: '025', label: 'erdő' },
    { value: '026', label: 'erdősor' },
    { value: '027', label: 'fasor' },
    { value: '028', label: 'fasora' },
    { value: '029', label: 'felső' },
    { value: '030', label: 'forduló' },
    { value: '031', label: 'föld' },
    { value: '032', label: 'főmérnökség' },
    { value: '033', label: 'főtér' },
    { value: '034', label: 'főút' },
    { value: '035', label: 'gát' },
    { value: '036', label: 'gátőrház' },
    { value: '037', label: 'gátsor' },
    { value: '038', label: 'gyár' },
    { value: '039', label: 'gyártelep' },
    { value: '040', label: 'gyógypark' },
    { value: '041', label: 'gyűjtőút' },
    { value: '042', label: 'gyümölcsös' },
    { value: '043', label: 'határsor' },
    { value: '044', label: 'határút' },
    { value: '045', label: 'ház' },
    { value: '046', label: 'hegy' },
    { value: '047', label: 'hegyhát' },
    { value: '048', label: 'hegyhát dűlő' },
    { value: '049', label: 'hídfő' },
    { value: '050', label: 'ipartelep' },
    { value: '051', label: 'iskola' },
    { value: '052', label: 'játszó és ' },
    { value: '053', label: 'jav.alatt' },
    { value: '054', label: 'kapu' },
    { value: '055', label: 'kastély' },
    { value: '056', label: 'kert' },
    { value: '057', label: 'kertek' },
    { value: '058', label: 'kertje' },
    { value: '059', label: 'kertsor' },
    { value: '060', label: 'kilátó' },
    { value: '061', label: 'kolónia' },
    { value: '062', label: 'korzó' },
    { value: '063', label: 'körönd' },
    { value: '064', label: 'körtér' },
    { value: '065', label: 'körút' },
    { value: '066', label: 'körútja' },
    { value: '067', label: 'körvasútsor' },
    { value: '068', label: 'körzet' },
    { value: '069', label: 'köz' },
    { value: '070', label: 'kultúrpark' },
    { value: '071', label: 'kunyhó' },
    { value: '072', label: 'kültelek' },
    { value: '073', label: 'lakóház' },
    { value: '074', label: 'lakónegyed' },
    { value: '075', label: 'lakópark' },
    { value: '076', label: 'lakótelep' },
    { value: '077', label: 'lejáró' },
    { value: '078', label: 'lejtő' },
    { value: '079', label: 'lépcső' },
    { value: '080', label: 'liget' },
    { value: '081', label: 'magánút' },
    { value: '082', label: 'major' },
    { value: '083', label: 'malom' },
    { value: '084', label: 'mellékköz' },
    { value: '085', label: 'mélyút' },
    { value: '086', label: 'menedékház' },
    { value: '087', label: 'munkásszálló' },
    { value: '088', label: 'műút' },
    { value: '089', label: 'oldal' },
    { value: '090', label: 'őrház' },
    { value: '091', label: 'őrházak' },
    { value: '092', label: 'őrházlak' },
    { value: '093', label: 'ösvény' },
    { value: '094', label: 'pályaudvar' },
    { value: '095', label: 'park' },
    { value: '096', label: 'parkja' },
    { value: '097', label: 'part' },
    { value: '098', label: 'pavilonsor' },
    { value: '099', label: 'piac' },
    { value: '100', label: 'pihenő' },
    { value: '101', label: 'pihenőpark' },
    { value: '102', label: 'pince' },
    { value: '103', label: 'pincesor' },
    { value: '104', label: 'puszta' },
    { value: '105', label: 'rakpart' },
    { value: '106', label: 'repülőtér' },
    { value: '107', label: 'rész' },
    { value: '108', label: 'rét' },
    { value: '109', label: 'sánc' },
    { value: '110', label: 'sarok' },
    { value: '111', label: 'sétány' },
    { value: '112', label: 'sikátor' },
    { value: '113', label: 'sor' },
    { value: '114', label: 'sora' },
    { value: '115', label: 'sportpálya' },
    { value: '116', label: 'sporttelep' },
    { value: '117', label: 'sugárút' },
    { value: '118', label: 'szállás' },
    { value: '119', label: 'szállások' },
    { value: '120', label: 'szél' },
    { value: '121', label: 'szer' },
    { value: '122', label: 'sziget' },
    { value: '123', label: 'szivattyútelep' },
    { value: '124', label: 'szőlő' },
    { value: '125', label: 'szőlőhegy' },
    { value: '126', label: 'szőlők' },
    { value: '127', label: 'tag' },
    { value: '128', label: 'tanya' },
    { value: '129', label: 'tanyák' },
    { value: '130', label: 'telep' },
    { value: '131', label: 'téli kikötő' },
    { value: '132', label: 'temető' },
    { value: '133', label: 'tér' },
    { value: '134', label: 'tere' },
    { value: '135', label: 'tető' },
    { value: '136', label: 'tömb' },
    { value: '137', label: 'turistaház' },
    { value: '138', label: 'udvar' },
    { value: '139', label: 'út' },
    { value: '140', label: 'utak' },
    { value: '141', label: 'utca' },
    { value: '142', label: 'utcája' },
    { value: '143', label: 'útgyűrű' },
    { value: '144', label: 'útja' },
    { value: '145', label: 'útőrház' },
    { value: '146', label: 'üdülő' },
    { value: '147', label: 'üdülő-part' },
    { value: '148', label: 'üdülő-sor' },
    { value: '149', label: 'üdülő-telep' },
    { value: '150', label: 'vadászház' },
    { value: '151', label: 'vár' },
    { value: '152', label: 'vasútállomás' },
    { value: '153', label: 'vasúti megálló' },
    { value: '154', label: 'vasúti őrház' },
    { value: '155', label: 'vasútsor' },
    { value: '156', label: 'védett nemesi ' },
    { value: '157', label: 'villasor' },
    { value: '158', label: 'vízmű' },
    { value: '159', label: 'völgy' },
    { value: '160', label: 'zug' },
    { value: '161', label: 'zsilip' },
];
